import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CheckoutPage } from './pages/CheckoutPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<CheckoutPage data-id="element-3" />} data-id="element-2" />
        <Route path="/contactanos" element={<ContactPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}